import React from 'react'
import Marquee from "react-fast-marquee";
const Ticker = () => {
    return (
        <>
            <div className="marquee-wrapper" >
                <Marquee>
                    <p style={{margin:'0px'}}>
                        * EERNA is the top ICT based shop in Bangladesh. Determine to provide
                        you the best price with better service. Available all kind of IT
                        products
                    </p>
                </Marquee>
            </div>

        </>
    )
}

export default Ticker